import { ReactNode } from 'react';
import PageShell from '../components/PageShell';

const CONTACT_EMAIL = 'nousrire.contact@gmail.com';

// Legal details of the association, as registered (RNA and Sirene). Empty fields are not displayed.
export const legalInfo = {
  name: "Nous'Rire",
  status: 'Association loi 1901',
  headOffice: '17 rue Gustave Eiffel, 92110 Clichy',
  rna: 'W922022362',
  siren: '991314733',
  publicationDirector: 'Wassim Badraoui',
};

const Block = ({ title, children }: { title: string; children: ReactNode }) => (
  <section className="mb-10">
    <h2 className="heading text-2xl mb-4">{title}</h2>
    <div className="space-y-3 text-brand-pink-900/80 leading-relaxed">{children}</div>
  </section>
);

const Legal = () => (
  <PageShell title="Mentions légales et confidentialité">
    <article className="max-w-3xl mx-auto">
      <p className="eyebrow mb-3">Informations légales</p>
      <h1 className="heading text-4xl md:text-5xl mb-12">Mentions légales et confidentialité</h1>

      <Block title="Éditeur du site">
        <p>
          {legalInfo.name}, {legalInfo.status.toLowerCase()}.
          {legalInfo.headOffice && <> Siège : {legalInfo.headOffice}.</>}
          {legalInfo.rna && <> Numéro RNA : {legalInfo.rna}.</>}
          {legalInfo.siren && <> SIREN : {legalInfo.siren}.</>}
        </p>
        {legalInfo.publicationDirector && <p>Directeur ou directrice de la publication : {legalInfo.publicationDirector}.</p>}
        <p>Contact : <a className="text-accent underline underline-offset-4" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
      </Block>

      <Block title="Hébergement">
        <p>
          Le site est hébergé par Firebase Hosting, service de Google Ireland Limited,
          Gordon House, Barrow Street, Dublin 4, Irlande.
        </p>
      </Block>

      <Block title="Données personnelles">
        <p>
          Quand vous proposez votre aide via le formulaire « Devenir bénévole », nous recueillons
          votre nom, votre adresse e-mail, votre téléphone, votre âge, votre ville, vos disponibilités,
          vos compétences et votre message.
        </p>
        <p>
          Ces informations servent uniquement à étudier votre candidature et à vous recontacter pour
          organiser nos actions. Elles sont traitées sur la base de votre consentement, donné en cochant
          la case prévue dans le formulaire. Elles ne sont ni vendues ni transmises à des tiers.
        </p>
        <p>
          Elles sont enregistrées dans les services Google (Firebase et Google Sheets) utilisés par
          l'association, et seuls les membres de l'équipe chargés des bénévoles y ont accès. Elles sont
          conservées deux ans après notre dernier échange, puis supprimées.
        </p>
        <p>
          Vous pouvez à tout moment demander à consulter, corriger ou supprimer vos données, ou retirer
          votre consentement, en écrivant à{' '}
          <a className="text-accent underline underline-offset-4" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          Si vous estimez que vos droits ne sont pas respectés, vous pouvez saisir la CNIL (cnil.fr).
        </p>
      </Block>

      <Block title="Cookies et stockage">
        <p>
          Le site n'utilise ni cookie publicitaire ni outil de mesure d'audience. Il garde seulement en
          mémoire, dans votre navigateur, le thème clair ou sombre que vous avez choisi. Les polices
          d'écriture sont chargées depuis Google Fonts.
        </p>
      </Block>

      <Block title="Photos et contenus">
        <p>
          Les photos et textes du site appartiennent à {legalInfo.name}, sauf mention contraire. Les logos
          des partenaires restent la propriété de leurs titulaires. Pour toute demande de retrait,
          écrivez-nous.
        </p>
      </Block>
    </article>
  </PageShell>
);

export default Legal;
